<template>
  <b-container>
    <h4>Titel:</h4>
    <b-form-input v-model="article.title"></b-form-input>
    <hr class="mt-4 mb-4">
    <h4>Inhalt:</h4>
    <trumbowyg v-model="article.content" :config="config" class="form-control" name="content"></trumbowyg>

    <h4>Vorschau:</h4>
    <b-textarea v-model="article.preview" class="form-control"></b-textarea>

    <h4 class="mt-4">Sichtbarkeit:</h4>
    <b-form-radio v-model="article.public" name="some-radios" value="1">Öffentlich</b-form-radio>
    <b-form-radio v-model="article.public" name="some-radios" value="0">Privat</b-form-radio>

    <h4 class="mt-4">Veröffentlicht am:</h4>
    <b-form-datepicker
        locale="de"
        start-weekday="1"
        placeholder="Kein Datum ausgewählt"
        :value="article.public_at"
        menu-class="w-100"
        calendar-width="100%"
        class="mb-2"
    />

    <h4 class="mt-4">Bilder:</h4>
    <Slider :slider="article.slider" :create="create"></Slider>

    <hr class="mt-4 mb-4">

    <b-button v-if="create" variant="success" block @click="createArticle(article)"
              style="margin-top: 10px; margin-bottom: 10px;">Erstellen
    </b-button>
    <b-button v-if="!create" variant="success" block @click="storeArticle(article)"
              style="margin-top: 10px; margin-bottom: 10px;">Speichern
    </b-button>

    <b-button v-if="!create" variant="outline-danger" block @click="confirmDeleteArticle(article)"
              style="margin-top: 10px; margin-bottom: 10px;">Löschen
    </b-button>
  </b-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Slider from "@/components/Article/Slider";
import 'jquery-resizable-dom';
import '@/trumbowyg.multiupload';
import '@/trumbowyg.table';
import '@/trumbowyg.fontsize'
import '@/trumbowyg.resizimg';
import '@/trumbowyg.fontfamily'

export default {
  name: "ArticleEdit",
  components: {Slider},
  props: {
    create: Boolean
  },
  data() {
    return {
      articleId: parseInt(this.$route.params.articleId),
      config: {
        tagsToRemove: ['script'],
        lang: 'de',
        imageWidthModalEdit: true,
        disabled() {
          return this.article === undefined;
        },
        btns: [
          ['undo', 'redo'], // Only supported in Blink browsers
          ['formatting', 'fontsize', 'fontfamily', 'horizontalRule'],
          ['strong', 'em', 'del', 'removeformat'],
          ['link', 'multiupload', 'table'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['fullscreen'],
        ],
        plugins: {
          multiupload: {
            apiUrl: process.env.VUE_APP_API_URL + '/file',
            authToken: `${this.authToken}`
          },
          fontsize: {
            sizeList: [
              '11px',
              '12px',
              '14px'
            ],
            allowCustomSize: true
          },
          fontfamily: {
            fontList: [
              {name: 'Arial', family: 'Arial, Helvetica, sans-serif'},
              {name: 'Open Sans', family: '\'Open Sans\', sans-serif'},
              {name: 'Calibri', family: 'Calibri, sans-serif'},
            ]
          }
        }
        // https://alex-d.github.io/Trumbowyg/documentation
      },
    }
  },
  computed: {
    ...mapGetters([
      'getStoredArticleById',
      'getNewArticle',
      'getAuthToken',
    ]),
    article() {
      if (this.create) return this.getNewArticle
      return this.getStoredArticleById(this.articleId)
    },
    disabled() {
      return this.article.content === undefined
    },
    authToken() {
      return this.getAuthToken
    }
  },
  mounted() {
    if (!this.create) this.getArticleById(this.articleId)
    if (this.create) this.setPublicAtToNow()
  },
  methods: {
    ...mapActions([
      'getArticleById',
      'storeArticle',
      'createArticle',
      'deleteArticle'
    ]),
    confirmDeleteArticle(article) {
      this.$bvModal.msgBoxConfirm('Wollen Sie den Artikel wirklich löschen ?', {
        title: 'Löschen',
        okVariant: 'outline-danger',
        okTitle: 'Ja',
        cancelTitle: 'Abbrechen',
        cancelVariant: 'outline-success',
        centered: true
      })
          .then(value => {
            if (value) {
              this.deleteArticle(article)
            }
          })
    },
    setPublicAtToNow() {
      const year = new Date().getFullYear()
      const month = ('0' + (new Date().getMonth() + 1)).slice(-2)
      const day = ('0' + new Date().getDate()).slice(-2)
      this.article.public_at = year + '-' + month + '-' + day
    },
  }
}
</script>
